module.exports = __webpack_public_path__ + "static/examp5-f7c144b6d6633665b208348f8f4276b4.gif";